import(/* webpackMode: "eager", webpackExports: ["RegisterPage"] */ "/app/apps/royalur/src/app/(auth)/register/RegisterPage.tsx");
